"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M5.398 16.2h8.062a.908.908 0 00.898-.918V8.718a.908.908 0 00-.898-.919H5.398a.908.908 0 00-.898.919v6.563c0 .507.402.918.898.918zM19.064 15.16l-3.097-1.61v-3.1l3.097-1.61c.198-.103.434.046.434.274v5.772c0 .23-.234.377-.434.274z" }), "Video");
//# sourceMappingURL=Video.js.map